import * as React from 'react';
import {NavLink, Outlet} from 'react-router-dom';
import {useBreadcrumb} from 'src/Breadcrumbs';
import {cn} from 'src/lib/utils';

const tabClass = ({isActive}: {isActive: boolean}) =>
  cn(
    'shrink-0 whitespace-nowrap border-b-2 px-1 pb-2 text-sm font-medium no-underline transition',
    isActive
      ? 'border-primary text-foreground'
      : 'text-muted-foreground hover:text-foreground border-transparent',
  );

/**
 * Layout route for /investments: the tab strip (same pattern as the account
 * detail page) with each tab as a nested route. Overview is the everyday
 * glance-and-navigate view (summary, chart, account list); Performance is
 * the analysis room (the per-account returns matrix, and any future
 * per-period views in that family); Holdings lists every security held.
 */
export const InvestmentsPage = () => {
  useBreadcrumb({label: 'Investments', reset: true});

  return (
    <div className="flex flex-1 flex-col overflow-hidden">
      <nav className="border-border flex gap-5 overflow-x-auto border-b px-4 pt-4 [scrollbar-width:none] sm:px-8">
        <NavLink to="/investments" end className={tabClass}>
          Overview
        </NavLink>
        <NavLink to="/investments/holdings" className={tabClass}>
          Holdings
        </NavLink>
        <NavLink to="/investments/reconcile" className={tabClass}>
          Reconcile
        </NavLink>
        <NavLink to="/investments/performance" className={tabClass}>
          Performance
        </NavLink>
      </nav>
      <div className="flex flex-1 flex-col overflow-hidden">
        <Outlet />
      </div>
    </div>
  );
};
